import { Component, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";

@Component({ selector: "app-subscription-manager", template: "" })
export class SubscriptionManager implements OnDestroy {
  /**
   * Add subscription to be automatically cleaned up on component destroy.
   *
   * @example
   * this.sub = this.myService.getData().subscribe(...);
   */
  set sub(subscription: Subscription) {
    this.subscriptions.push(subscription);
  }

  private subscriptions: Subscription[] = [];

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.forEach((sub) => {
        sub.unsubscribe();
      });
    }
    this.subscriptions = [];
  }
}
